import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div<{ $isInactive?: boolean }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  ${props => (props.$isInactive ? 'opacity: 0.5;' : '')}
`;

type LeftProps = {
  $stickLabelToTop?: boolean;
  $noPadding?: boolean;
};

const LeftBlock = styled.div<LeftProps>`
  flex: 1;
  display: flex;
  ${props =>
    props.$stickLabelToTop
      ? 'align-self: flex-start; margin-top 8px;'
      : 'align-items: center;'}
  padding: ${props => (props.$noPadding ? 0 : '8px 0 0 0')};
  color: var(--gray4c);
`;

const RightBlock = styled.div<{ $noPadding: boolean }>`
  flex: 4;
  width: 100%;
  word-break: break-word;
  padding: ${props => (props.$noPadding ? 0 : '8px 0')};
  text-align: left;
`;

interface PanelProps {
  label?: ReactNode;
  children: ReactNode;
  stickLabelToTop?: boolean;
  noPadding?: boolean;
  inactive?: boolean;
  /**
   * The `id` of the input that the label associates with.  Note that even when id overlaps
   * occur the browser looks for the input closest to the label and uses that.
   */
  htmlFor?: string;
}

const LabelInputPanel = ({
  label,
  children,
  noPadding,
  stickLabelToTop,
  inactive,
  htmlFor,
}: PanelProps) => (
  <Wrapper $isInactive={inactive}>
    {label ? (
      <LeftBlock $noPadding={noPadding} $stickLabelToTop={stickLabelToTop}>
        <label style={{ cursor: 'pointer' }} htmlFor={htmlFor}>
          {label}
        </label>
      </LeftBlock>
    ) : null}
    <RightBlock $noPadding={!!noPadding}>{children}</RightBlock>
  </Wrapper>
);

export default LabelInputPanel;
